// @flow

import {observable, action} from 'mobx'

class AdminStore {
  @observable isMedicineInfoVisible: boolean = false
  @observable medicines: Array<Object> = []
  @observable activeMedicinePage: number = 0
  @observable maxMedicinePages: number = 0
  @observable pagedMedicines: Array<Object> = []
  @observable newMedicines: Array<Object> = []
  @observable footerLabels: Object = {}
  @observable savedFooterLabels: Object = {}
  @observable newMedicineInfos: Array<Object> = []

  @action
  saveIsMedicineInfoVisible = (newValue: boolean) => {
    this.isMedicineInfoVisible = newValue
  }
  saveMedicines = (medicines: Array<Object>) => {
    this.medicines = medicines
  }
  saveActiveMedicinePage = (page: number) => {
    this.activeMedicinePage = page
  }
  saveMaxMedicinePage = (max: number) => {
    this.maxMedicinePages = max
  }
  savePagedMedicines = (medicines: Array<Object>) => {
    this.pagedMedicines = medicines
  }
  saveNewMedicines = (medicines: Array<Object>) => {
    this.newMedicines = medicines
  }
  saveFooterLabels = (footerLabels: Object) => {
    const newFooterLabels = {
      searchTitle: footerLabels.searchTitle,
      searchDescription: footerLabels.searchDescription,
      searchPlaceholder: footerLabels.searchPlaceholder,
      searchInstruction: footerLabels.searchInstruction,
      company: footerLabels.company,
      description: footerLabels.description,
      phone: footerLabels.phone,
      copyright: footerLabels.copyright,
      queueInfo: footerLabels.queueInfo,
    }
    this.footerLabels = newFooterLabels
  }
  saveSavedFooterLabels = (footerLabels: Object) => {
    const newFooterLabels = {
      searchTitle: footerLabels.searchTitle,
      searchDescription: footerLabels.searchDescription,
      searchPlaceholder: footerLabels.searchPlaceholder,
      searchInstruction: footerLabels.searchInstruction,
      company: footerLabels.company,
      description: footerLabels.description,
      phone: footerLabels.phone,
      copyright: footerLabels.copyright,
      queueInfo: footerLabels.queueInfo,
    }
    this.savedFooterLabels = newFooterLabels
  }
  saveNewMedicineInfos = (medicineInfos: Array<Object>) => {
    this.newMedicineInfos = medicineInfos
  }
}

export default new AdminStore()



// WEBPACK FOOTER //
// ./src/admin/store.js